import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** The payload as an inline SVG (the `qrcode` package; own content, never user HTML). `null` while empty or pending. */
export function useQrSvg(payload: string): string | null {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    if (payload === "") {
      setSvg(null);
      return;
    }
    QRCode.toString(payload, { type: "svg", margin: 1 })
      .then((s) => {
        if (live) setSvg(s);
      })
      .catch(() => {
        if (live) setSvg(null);
      });
    return () => {
      live = false;
    };
  }, [payload]);
  return svg;
}
